/* eslint-disable no-lone-blocks */
/* eslint-disable react/require-default-props */
import { useToggle } from 'hooks';
import { memo, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
// SERVICEs
import {
  Notification,
  useUpdateNotificationStatus,
} from 'services/notifications';
import { useRetrieveRequestingReschedule } from 'services/schedule';

// COMPs
import { Avatar, Icon, Text, notification as Toast } from '@antoree/ant-ui';
import {
  Body,
  useUpdateApprovalReschedule,
} from 'services/schedule/updateApprovalReschedule';
import { IRequestingReschedule } from 'types/IRequestingReschedule';
import { useCurrentUser } from 'contexts';
import ReScheduleModal from './components/ReScheduleModal';

import {
  NOTIFICATION_STATUS_ABSENCE_RESCHEDULE,
  NOTIFICATION_TYPE_ABSENCE,
  NOTIFICATION_TYPE_AUTO_MATCHING,
  NOTIFICATION_TYPE_REMIND,
} from './constants';
import styles from './Notification.module.scss';
import { fromNow, getNotificationIconType } from './utils';
import { getScheduleConflictOrMessage } from 'utils/scheduleConflictMessages';

type Props = {
  notification: Notification | null;
  width: string;
  closePopoverNotification?: () => void;
};

const NotificationCard = ({
  closePopoverNotification,
  notification,
  width,
}: Props) => {
  const { formatMessage } = useIntl();
  const {
    id,
    isRead,
    content,
    image,
    createdAt,
    type,
    status,
    contentId,
    contentBold,
    skype,
    courseId,
  } = notification || {};
  const [selectedUnitId, setSelectedUnitId] = useState(0);

  const { mutate } = useUpdateNotificationStatus();

  const { days, hours, minutes } = fromNow(createdAt || '');

  const {
    isVisiable,
    toggle: toggleReschedule,
    open: openReschedule,
  } = useToggle();

  const history = useHistory();

  const { data } = useRetrieveRequestingReschedule(
    { unitId: selectedUnitId || 0 },
    {
      enabled: Boolean(selectedUnitId),
      refetchOnMount: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    },
  );

  const {
    mutate: mutateApprovalReschedule,
    isLoading: isLoadingAprroval,
  } = useUpdateApprovalReschedule({
    onSuccess: () => {
      Toast.success({
        title: <p>Update successfully</p>,
      });
      toggleReschedule();
    },
    onError: err => {
      const { lines, fallback } = getScheduleConflictOrMessage(
        err,
        formatMessage,
      );
      if (lines.length) {
        Toast.error({
          title: <p>{lines[0]}</p>,
          text:
            lines.length > 1 ? (
              <div>
                {lines.slice(1).map((line, i) => (
                  <p key={i} style={{ marginTop: 6 }}>
                    {line}
                  </p>
                ))}
              </div>
            ) : undefined,
        });
        return;
      }
      Toast.error({
        title: <p>Error</p>,
        text: <p>{fallback ?? 'Update failed'}</p>,
      });
    },
  });
  const currentUser = useCurrentUser();
  const { id: teacherId } = currentUser;
  const handleUpdateApprovalReschedule = (
    dataReschedule: IRequestingReschedule,
  ) => {
    const { id: scheduleId } = dataReschedule;
    if (notification?.contentId) {
      mutateApprovalReschedule({
        course_id: courseId || 0,
        schedule_id: scheduleId !== '0' ? scheduleId : null,
        status: scheduleId !== '0' ? 1 : 2,
        teacher_id: teacherId,
        unit_id: contentId || 0,
      });
    }
  };

  const handleClickNotification = (
    idNotification: number | undefined,
    idDetail: number | undefined,
    notificationDetail: Notification | null,
  ) => {
    mutate({
      id: idNotification,
      isRead: 1,
    });

    switch (type) {
      case NOTIFICATION_TYPE_REMIND:
        if (skype) {
          window.location.href = `skype:${skype}?chat`;
        }
        break;
      case NOTIFICATION_TYPE_ABSENCE:
        if (status === NOTIFICATION_STATUS_ABSENCE_RESCHEDULE) {
          openReschedule();
          if (!contentId) {
            Toast.error({
              title: <p>Error</p>,
              text: <p>Not found unit ID</p>,
            });
            return;
          }
          setSelectedUnitId(contentId);
        }
        break;
      case NOTIFICATION_TYPE_AUTO_MATCHING:
        {
          history.push({
            pathname: `/booking-list/${idDetail}`,
            state: `${JSON.stringify({
              ...notificationDetail,
              timeBetween,
            })}`,
          });
          closePopoverNotification && closePopoverNotification();
        }
        break;
      default:
        break;
    }
  };
  const timeBetween = useMemo(() => {
    if (days === 0 && hours === 0 && minutes === 0) {
      return `vài giây trước`;
    }
    if (days === 0 && hours === 0) {
      return `${minutes} phút trước`;
    }
    if (days === 0) {
      return `${hours} giờ trước`;
    }
    return `${days} ngày trước`;
  }, [days, hours, minutes]);
  let string: any = content;

  contentBold?.forEach((item: any) => {
    if (content?.includes(item)) {
      string = string?.replace(item, ` ${item.bold()}`);
    }
  });

  return (
    <>
      <button
        type="button"
        className="rounded-lg hover:bg-gray-100 "
        onClick={() => handleClickNotification(id, contentId, notification)}
      >
        <div className="cursor-pointer px-2 pt-2 flex gap-3">
          <div className="flex flex-col py-0 ">
            {type === NOTIFICATION_TYPE_REMIND ? (
              <Avatar
                className="w-14 h-14 pointer-events-none"
                name="System"
                iconType="bell"
                color="#14B24C"
                iconColor="white"
                size="l"
              />
            ) : (
              image && (
                <>
                  {type === NOTIFICATION_TYPE_AUTO_MATCHING && status !== 6 ? (
                    <Avatar
                      className="w-14 h-14 pointer-events-none"
                      name="Custom iconColor"
                      iconType="cross"
                      color="#ED0000"
                      iconColor="white"
                      size="l"
                    />
                  ) : (
                    <Avatar
                      name="avatar"
                      imageUrl={image}
                      className="w-14 h-14"
                    />
                  )}
                  <Icon
                    size="l"
                    type={getNotificationIconType(type)}
                    className={styles.IconNotification}
                  />
                </>
              )
            )}
          </div>
          <div className="text-left text-sm">
            <Text size="s" dangerouslySetInnerHTML={{ __html: string }} />
            <Text size="s" className="font-light">
              {moment(createdAt).format('HH:mm MMM Do YYYY')}
            </Text>
          </div>
          <div className="ml-auto">
            {!isRead && <Icon type="dot" color="primary" />}
          </div>
        </div>
      </button>
      {isVisiable && data?.data && (
        <ReScheduleModal
          absent={data?.data?.unit}
          requestSchedule={data?.data?.requestSchedule}
          onClose={toggleReschedule}
          isLoading={isLoadingAprroval}
          onUpdateApprovalReschedule={handleUpdateApprovalReschedule}
          responsiveSchedule={data.data.responsiveSchedule}
        />
      )}
    </>
  );
};

export default memo(NotificationCard);
